// src/components/DBSchemaNode.jsx
import React from "react";

/* DB SCHEMA NODE HEADER ------------------------------------------------ */
export const DBSchemaNodeHeader = ({ children, isView }) => {
  return (
    <div
      className="p_2 text_center font_size_small font_weight_medium"
      style={{
        color: "var(--builder-font-color)",
        backgroundColor: `${isView ? "rgb(151, 191, 255)" : "var(--builder-plain)"}`
      }}
    >
      {children}
    </div>
  );
};

/* DB SCHEMA NODE BODY ------------------------------------------------- */
export const DBSchemaNodeBody = ({ children }) => {
  return (
    <table className="w-full border-collapse" style={{ backgroundColor: "var(--builder-bg-light)" }}>
      <tbody>{children}</tbody>
    </table>
  );
};

/* DB SCHEMA TABLE ROW ------------------------------------------------- */
export const DBSchemaTableRow = ({ children, className }) => {
  return <tr className={`relative text-xs ${className || ""}`}>{children}</tr>;
};

/* DB SCHEMA TABLE CELL ------------------------------------------------ */
export const DBSchemaTableCell = ({ children, className }) => {
  return (
    <td className={`border-t p-1 ${className || ""}`} style={{ borderColor: "var(--builder-border)" }}>
      {children}
    </td>
  );
};

/* DB SCHEMA NODE ------------------------------------------------------ */
export const DBSchemaNode = ({ children, className }) => {
  return (
    <div
      className={`rounded-md border shadow-sm ${className}`}
      style={{ borderColor: "var(--builder-border)", color: "var(--builder-text-white)" }}
    >
      {children}
    </div>
  );
};
